import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from 'axios';
import SvgProgramming from "../components/svg/SvgProgramming";

function About() {
    const [aboutData, setAboutData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function getItem() {
            try {
                const response = await axios.get("https://admin.maviada.co/api/hakkimizda");
                if (response?.data?.data?.length > 0) {
                    setAboutData(response.data.data[0]);
                } else {
                    console.warn("API verisi beklenen formatta değil:", response.data);
                    setError("Veri bulunamadı.");
                }
            } catch (err) {
                console.error("API hatası:", err);
                setError("Veri alınırken hata oluştu.");
            }
        }
        getItem();
    }, []);

    if (error) {
        return <div className="text-center mt-5 text-danger">{error}</div>;
    }

    if (!aboutData) {
        return <div className="text-center mt-5">Yükleniyor...</div>;
    }

    return (
        <div className='hero page-wrapper'>
            <section className='hero'>
                <Container>
                    <Row className="justify-content-center">
                        <Col md={7} lg={6}>
                            <h4 className='mb-3 text-uppercase breadcrumb-text'>ANASAYFA / {aboutData.title} -</h4>
                            <h2 className='mb-3 text-uppercase'>{aboutData.title}</h2>
                            <p dangerouslySetInnerHTML={{ __html: aboutData.text }}></p>
                        </Col>
                        <Col md={5} lg={4}>
                            <div className='about-icon'>
                                <SvgProgramming />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default About;
